import { Injectable } from '@angular/core';
import {ParametresItService} from 'global/services/parametres/parametres-it.service';
import {ParametresEnService} from 'global/services/parametres/parametres-en.service';
import {ParametresService} from 'global/services/parametres/parametres.service';
import {TranslateService} from '@ngx-translate/core';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class BvTranslateService {

  currentLang;

  private familleRed2LegacyMap: { [oldValue: string]: string } = {
    'Autres eaux usées et dérivés': 'Autres eaux usées et dérivées',
    'Biodéchet': 'Biodéchets',
    'biodéchets': 'Biodéchets',
    'Fraction biomasse des déchets municipaux mélangés': 'Fraction de biomasse des déchets municipaux',
    'Fraction de biomasse des déchets municipaux mélangés': 'Fraction de biomasse des déchets municipaux',
    'Glycérine brute': 'Glycérine Brute',
    'Huile technique de maïs': 'Huile de maïs technique',
    'Plant entier de tournesol': 'Plante entière de tournesol'
  };

  // "L'huile de maïs" reste une valeur valide du référentiel ISCC : la migration
  // vers "Huile de maïs" ne doit s'appliquer qu'au schéma 2bsvs, où c'était un doublon.
  private familleRed2LegacyMapByScheme: { [scheme: string]: { [oldValue: string]: string } } = {
    '2bsvs': {
      "L'huile de maïs": 'Huile de maïs'
    }
  };

  constructor(
      private parametresFrService: ParametresService,
      private parametresItService: ParametresItService,
      private parametresEnService: ParametresEnService,
      private translateService: TranslateService
  ) {
    this.currentLang = this.translateService.currentLang;
  }

  getParametres(currentLang?: string) {
    if (currentLang) {
      this.setLang(currentLang);
    }
    switch (this.currentLang) {
      case 'it': {
        return this.parametresItService.getParametres();
        break;
      }
      case 'en' : {
        return this.parametresEnService.getParametres();
        break;
      }
      default : {
        return this.parametresFrService.getParametres();
        break;
      }
    }
  }

  getLocale(currentLang?: string) {
    if (currentLang) {
      this.setLang(currentLang);
    }
    switch (this.currentLang) {
      case 'it': {
        return 'it-IT';
      }
      case 'fr' : {
        return 'fr-FR';
      }
    }
  }

  getTypeTiers(id) {
    switch (this.currentLang) {
      case 'it': {
        return _.find(this.parametresItService.getParametres().typeTiers, ['id', id]).label;
      }
      case 'fr' : {
        return _.find(this.parametresFrService.getParametres().typeTiers, ['id', id]).label;
      }
    }
  }

  setLang(lang: string) {
    this.currentLang = lang;
  }

  /**
   * Convertit une ancienne valeur de famille RED II (retirée du référentiel) vers son équivalent actuel.
   * `scheme` (ex. '2bsvs', 'iscc') permet de n'appliquer une correspondance que pour le schéma volontaire
   * concerné, car une même valeur peut être un doublon retiré dans un schéma et rester valide dans un autre.
   * Renvoie la valeur telle quelle si elle n'a pas de correspondance connue.
   */
  migrateFamilleRed2(value: string, scheme?: string): string {
    if (!value) {
      return value;
    }
    const schemeMap = scheme ? this.familleRed2LegacyMapByScheme[scheme] : undefined;
    if (schemeMap && schemeMap[value]) {
      return schemeMap[value];
    }
    return this.familleRed2LegacyMap[value] ? this.familleRed2LegacyMap[value] : value;
  }
}
